import React, { useContext } from 'react';
import { Row, Col, Button } from 'antd';
import { useCookies } from 'react-cookie';
import { Link } from 'react-router-dom';
import { SIGNIN, SIGNUP } from '../../route/AppRouter';
// import { signUp } from '../../api';
import { StoreContext } from '../../context/store/storeContext';
import SEO from '../../components/SEO';

const Sitemap = () => {
    const { actions } = useContext(StoreContext);
    const [cookies] = useCookies('SESSION');
    const redirectPage = (path) => {
        if (path === SIGNIN) {
            actions.dialogAction.openEntryDialog({ open: true, type: 'signin' });
        }
        if (path === SIGNUP) {
            actions.dialogAction.openEntryDialog({ open: true, type: 'signup' });
        }
    };

    const renderBeforeSignin = () => {
        return (
            <div className="sitemapLinks" key="before-login">
                <Button
                    style={{ color: '#070000', fontWeight: 300, fontSize: '1.6rem' }}
                    type="link"
                    onClick={() => {
                        redirectPage(SIGNIN);
                    }}
                >
                    SignIn
                </Button>
                <Button
                    style={{ color: '#070000', fontWeight: 300, fontSize: '1.6rem' }}
                    type="link"
                    onClick={() => {
                        redirectPage(SIGNUP);
                    }}
                >
                    SignUp
                </Button>
            </div>
        );
    };

    const renderAfterSignin = () => {
        return (
            <div className="sitemapLinks" key="after-login">
                <Link to={{ pathname: '/profile/detail', state: { index: 0 } }}>Profile</Link>
                <Link to="/subscriptions">Subscriptions</Link>
            </div>
        );
    };

    return (
        <div className="easyLeaseContainer">
            <SEO
                title="Site Map"
                description="A Complete and cost effective vehicle management solution from procurement to delivery, maintenance, replacement and after sales service."
                path="sitemap"
            />
            <Row justify="center" className="EasyleaseFaq">
                <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 24 }}
                    lg={{ span: 24 }}
                    xl={{ span: 24 }}
                    xxl={{ span: 24 }}
                >
                    <h1 className="EasyleaseFaqTitle">Sitemap</h1>
                </Col>

                <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 12 }}
                    lg={{ span: 12 }}
                    xl={{ span: 4 }}
                    xxl={{ span: 4 }}
                    className="menu-block-container"
                >
                    <h4 className="menu-header">Products</h4>
                    <div className="sitemapLinks">
                        <Link to="/vehicle">Easy Lease</Link>
                        <a href="https://carshare.yomafleet.com" target="_blank" rel="noopener noreferrer">
                            Car Share
                        </a>
                        <a href="https://trucktrailer.yomafleet.com" target="_blank" rel="noopener noreferrer">
                            Truck & Trailer
                        </a>
                        <a href="https://carsales.yomafleet.com" target="_blank" rel="noopener noreferrer">
                            Car Sales
                        </a>
                        <a href="https://yomaleasing.com/" target="_blank" rel="noopener noreferrer">
                            Lease To Buy
                        </a>
                    </div>
                </Col>

                <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 12 }}
                    lg={{ span: 12 }}
                    xl={{ span: 4 }}
                    xxl={{ span: 4 }}
                    className="menu-block-container"
                >
                    <h4 className="menu-header">Account</h4>
                    {[
                        cookies.SESSION === undefined
                            ? renderBeforeSignin()
                            : [cookies.SESSION.access_token === undefined ? renderBeforeSignin() : renderAfterSignin()],
                    ]}
                </Col>

                <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 12 }}
                    lg={{ span: 12 }}
                    xl={{ span: 5 }}
                    xxl={{ span: 5 }}
                    className="menu-block-container"
                >
                    <h4 className="menu-header">Easy Lease</h4>
                    <div className="sitemapLinks">
                        <Link to="/easylease">What is Easy Lease?</Link>
                        <Link to="/how-it-works">How Easy Lease works</Link>
                        <Link to="/terms-and-conditions">Terms & Conditions</Link>
                        <Link to="/fare-ware-and-tear">Fair Wear & Tear Policy</Link>
                        <Link to="/privacy-policy">Privacy Policy</Link>
                        <Link to="/faq">FAQs</Link>
                    </div>
                </Col>

                <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 12 }}
                    lg={{ span: 12 }}
                    xl={{ span: 4 }}
                    xxl={{ span: 4 }}
                    className="menu-block-container"
                >
                    <h4 className="menu-header">Company</h4>
                    <div className="sitemapLinks">
                        <Link to="/">Home</Link>
                    </div>
                    <div className="sitemapLinks">
                        <Link to="/about-us">About Us</Link>
                    </div>
                </Col>

                <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 12 }}
                    lg={{ span: 12 }}
                    xl={{ span: 4 }}
                    xxl={{ span: 4 }}
                    className="menu-block-container"
                >
                    <h4 className="menu-header">Support</h4>
                    <div className="sitemapLinks">
                        <Link to="/contact">Contact</Link>
                        <Link to="/feedback">Feedback</Link>
                    </div>
                </Col>
            </Row>
        </div>
    );
};

export default Sitemap;
